import React from "react";
import { BannerWrapper, BannerTitle,BannerSubTitle } from "./BannerStyled";
import BannerImg from "../../../../../Assets/Image/ReportDumping/Banner.svg";
const Banner = () => {
  return (
    <BannerWrapper src={BannerImg}>
        <span/>
      <BannerTitle>REPORT</BannerTitle>
      <BannerSubTitle>About for Price Dumping</BannerSubTitle>
    </BannerWrapper>
  );
};

export default Banner;
